import {t} from 'i18next'
import {Badge} from 'primereact/badge'
import {Tooltip} from 'primereact/tooltip'
import React from 'react'
import {ApprenticeshipModuleType} from '../../../../../model/enums/enums'
import {getModuleTypeIcon} from '../education-plan/utils/ModulePlanHelper'

/**
 * Returns the Module Type tag according to the type
 * @constructor
 * @param props
 */
export const ModuleTypeTag = (props: {
  moduleType: number | undefined;
}): JSX.Element => {
  let color = ''
  let label = ''

  const typeIcon = getModuleTypeIcon(props.moduleType)

  switch (props.moduleType) {
    case ApprenticeshipModuleType.ProfessionalModule:
      color = 'icon-blue'
      label = t('grade_module.module.type.professional_module')
      break
    case ApprenticeshipModuleType.SchoolSubject:
      color = 'icon-green'
      label = t('grade_module.module.type.school_subject')
      break
    case ApprenticeshipModuleType.Matura:
      color = 'icon-gold'
      label = t('grade_module.module.type.matura')
      break
    case ApprenticeshipModuleType.UEK:
      color = 'icon-dark-gray'
      label = t('grade_module.module.type.uek')
      break
    default:
      color = 'icon-red'
      label = 'unknown'
      break
  }

  return (
    <>
      <span className={`mr-2 ${color} small-text`}>
        <span className={`${typeIcon}`} />
        <span className={`small-text module-type-icon-${label}`}> {label}</span>
      </span>
      <Tooltip
        target={`.module-type-icon-${label}`}
        content={label}
        showDelay={1000}
      />
    </>
  )
}

export const ModuleKeyBadgeByType = (props: {
  moduleKey: string;
  moduleType: number | undefined;
}): JSX.Element => {
  let color = ''

  switch (props.moduleType) {
    case ApprenticeshipModuleType.ProfessionalModule:
      color = 'bg-blue'
      break
    case ApprenticeshipModuleType.SchoolSubject:
      color = 'bg-green'
      break
    case ApprenticeshipModuleType.Matura:
      color = 'bg-orange'
      break
    case ApprenticeshipModuleType.UEK:
      color = 'bg-dark-gray'
      break
    default:
      color = 'bg-red'
      break
  }

  return <Badge size={'normal'} value={props.moduleKey} className={color} />
}